import { StepRun } from "@/models/flows";
import { EyeIcon, EyeOffIcon, MailIcon } from "lucide-react";
import { useState } from "react";

interface Props {
  stepRun: StepRun;
}

export const SendEmail = ({ stepRun }: Props) => {
  const [showEmailBody, setShowEmailBody] = useState(false);
  return (
    <div>
      <div className="flex items-start">
        <div>
          <div className="dark:text-white">
            {stepRun.renderedConfig.subject}
          </div>
          <div className="flex mt-1 items-center">
            <MailIcon className="h-4 w-4 dark:text-zinc-500 mr-1.5" />
            <p className="dark:text-zinc-500">{stepRun.renderedConfig.to}</p>
          </div>
        </div>
        <div className="flex flex-1 justify-end mr-4">
          <button
            className="text-sm mt-1 dark:text-white"
            onClick={() => setShowEmailBody(!showEmailBody)}
          >
            {showEmailBody ? (
              <div className="flex items-center">
                <p>Hide email body</p>
                <EyeOffIcon className="w-4 h-4 text-white ml-1" />
              </div>
            ) : (
              <div className="flex items-center">
                <p>Show email body</p>
                <EyeIcon className="w-4 h-4 text-white ml-1" />
              </div>
            )}
          </button>
        </div>
      </div>
      <div className="">
        {showEmailBody && (
          <div
            className="prose dark:prose-invert mt-3 border dark:border-white/5 dark:bg-zinc-800 w-full rounded-md p-4"
            dangerouslySetInnerHTML={{ __html: stepRun.renderedConfig.body }}
          ></div>
        )}
      </div>
    </div>
  );
};
